import { useState } from "react";
import useTranslate from "hooks/useTranslate";
import useMeasure from "react-use-measure";
import { animated, useSpring } from "@react-spring/web";

// Containers
import ProviderFilterContainer from "containers/organisms/ProviderFilterContainer";

// Hooks
import { useGTM } from "hooks/useGTM";

// Icons
import Arrow from "assets/icons/arrowUp.svg?react";
import List from "assets/icons/glory/list.svg?react";

// Types
import { FilterType } from "redux/game/slice";

import "./styles.sass";

interface IProviderNavigation {
  isSidebarOpen: boolean;
  filter: FilterType;
  onClick: () => void;
}

const ProviderNavigation: React.FC<IProviderNavigation> = ({
  isSidebarOpen,
  filter,
  onClick,
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const t = useTranslate();
  const GTM = useGTM();
  const title =
    filter && filter.providers && filter.providers.length
      ? `${t("casino.providers.selected")} : ${filter.providers.length}`
      : `${t("casino.providers.category.all")}`;

  const toggleHandler = () => {
    if (isOpen) {
      GTM.closeProvidersFilter();
    } else {
      GTM.openProvidersFilter();
    }
    setIsOpen(!isOpen);
  };

  const shortListClickHandler = () => {
    onClick();
    setIsOpen(true);
  };

  const [providersRef, { height: heightElement }] = useMeasure();

  const { transform, height, opacity, width, x } = useSpring({
    transform: `rotate(${isOpen ? 0 : -180}deg)`,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    height: isOpen ? heightElement : 0,
    opacity: isSidebarOpen ? 1 : 0,
    width: isSidebarOpen ? 224 : 44,
    x: isSidebarOpen ? 8 : 16,
  });

  return (
    <div className="ProviderNavigation">
      <animated.div
        className="ProviderNavigation__seporator"
        style={{ width }}
      />
      {isSidebarOpen ? (
        <>
          <animated.div
            className="ProviderNavigation__title"
            // eslint-disable-next-line react/jsx-handler-names
            onClick={toggleHandler}
            style={{ opacity }}
          >
            {title}{" "}
            <animated.div
              className="ProviderNavigation__icon"
              style={{ transform }}
            >
              <Arrow />
            </animated.div>
          </animated.div>
          <animated.div
            className="ProviderNavigation__filter"
            style={{ height }}
          >
            <animated.div ref={providersRef}>
              <ProviderFilterContainer />
            </animated.div>
          </animated.div>
        </>
      ) : (
        <animated.div
          className="ProviderNavigation__short"
          style={{ x }}
          // eslint-disable-next-line react/jsx-handler-names
          onClick={shortListClickHandler}
        >
          <List />
        </animated.div>
      )}
    </div>
  );
};

export default ProviderNavigation;
